export default {
  apiKey: 'AIzaSyDdeg2ga2gD508X3kzAxtZROIXc-bX-mL4',
  // authDomain: 'feeding-archive.firebaseapp.com',
  // databaseURL: 'https://feeding-archive.firebaseio.com',
  projectId: 'feeding-archive',
  // storageBucket: 'feeding-archive.appspot.com',
  // messagingSenderId: '217801729531'
}
